import React from "react";
import { StatusIndicator } from "@cloudscape-design/components";
import { LABELS, REDRIVE_LABELS } from "../../constants";

export interface ExecutionItem {
  executionArn: string;
  status: string;
  startDate: string;
}

export interface RedriveErrorItem {
  parentFailedExecution?: string;
  error?: { errorMessage?: string };
}

const getStatusType = (status: string): "success" | "in-progress" => (status === "RUNNING" ? "in-progress" : "success");

const extractArnName = (arn?: string): string => arn?.split(":").pop() || arn || LABELS.EMPTY_VALUE;

function ExecutionArnCell(item: ExecutionItem): string {
  return extractArnName(item.executionArn);
}

function ExecutionStatusCell(item: ExecutionItem): JSX.Element {
  return <StatusIndicator type={getStatusType(item.status)}>{item.status}</StatusIndicator>;
}

function ExecutionStartCell(item: ExecutionItem): string {
  return item.startDate;
}

function ErrorExecutionCell(item: RedriveErrorItem): string {
  return extractArnName(item.parentFailedExecution);
}

function ErrorMessageCell(item: RedriveErrorItem): string {
  return item.error?.errorMessage ?? LABELS.EMPTY_VALUE;
}

export const executionColumnDefinitions = [
  { id: "arn", header: REDRIVE_LABELS.EXECUTION_ARN, cell: ExecutionArnCell },
  { id: "status", header: REDRIVE_LABELS.STATUS, cell: ExecutionStatusCell },
  { id: "start", header: REDRIVE_LABELS.STARTED, cell: ExecutionStartCell },
];

export const errorColumnDefinitions = [
  {
    id: "execution",
    header: REDRIVE_LABELS.FAILED_EXECUTION,
    cell: ErrorExecutionCell,
  },
  { id: "error", header: REDRIVE_LABELS.ERROR, cell: ErrorMessageCell },
];
